import classNames from 'classnames'
import { PropsWithChildren, createContext, useContext } from 'react'

import { Box } from '@shared/components/Box'

import styles from './PopoverCard.module.scss'

const PopoverCardModalSurfaceContext = createContext(false)

export const PopoverCardModalSurfaceProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <PopoverCardModalSurfaceContext.Provider value>
    {children}
  </PopoverCardModalSurfaceContext.Provider>
)

interface PopoverCardProps extends PropsWithChildren {
  maxHeight?: number
}

export const PopoverCard: React.FC<PopoverCardProps> = (props) => {
  const { children, maxHeight = 500 } = props
  const isModalSurface = useContext(PopoverCardModalSurfaceContext)

  return (
    <Box
      className={classNames(styles.dropdownCard, styles.typeDropdownCard, {
        [styles.modalSurface]: isModalSurface,
      })}
      gap={{ desktop: 'x8' }}
      maxHeight={{ desktop: maxHeight }}
      radius={{ desktop: 'x18', mobile: 'x0' }}
      border={{ desktop: 'outline-low-em' }}
      p={{ desktop: 'x8' }}
      minWidth={{ desktop: 64 }}
      overflowY={{ mobile: 'visible' }}
      fullWidth={{ mobile: true }}
      fullHeight={{ mobile: true }}
    >
      {children}
    </Box>
  )
}
